import { Checkbox, FormControlLabel, Typography } from "@mui/material";
import InputField from "components/Input/InputField";
import { gstAdjusted } from "utils/gstCalc";

const GstChargeField = ({
  label,
  checkboxLabel = "Include GST",
  placeholder = "0.00",
  amountName,
  amountValue,
  onAmountChange,
  gst,
  onGstChange,
  disabled = false,
}) => {
  const included = !!gst?.included;
  const rate = gst?.rate ?? "10";
  const final = gstAdjusted(amountValue, gst);

  return (
    <div>
      <InputField
        label={label}
        placeholder={placeholder}
        name={amountName}
        type="number"
        value={amountValue ?? ""}
        onChange={onAmountChange}
        disabled={disabled}
      />
      <div className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1">
        <FormControlLabel
          className="m-0"
          control={
            <Checkbox
              size="small"
              checked={included}
              disabled={disabled}
              onChange={(e) => onGstChange({ included: e.target.checked, rate })}
            />
          }
          label={<span className="text-xs text-app-text-secondary">{checkboxLabel}</span>}
        />
        {included && (
          <>
            <div className="w-20">
              <InputField
                placeholder="10"
                type="number"
                endIcon={<span className="text-xs text-app-text-muted">%</span>}
                value={rate}
                disabled={disabled}
                onChange={(e) => onGstChange({ included, rate: e.target.value })}
              />
            </div>
            <Typography variant="caption" className="text-app-text-secondary">
              Final: {final.toFixed(2)}
            </Typography>
          </>
        )}
      </div>
    </div>
  );
};

export default GstChargeField;
